export default __webpack_public_path__ + "static/media/faculty_avatar.1485828e.svg";